import config from '../config/config';
import Request from './index';

export const GetUsers = async () => {
  const endpoint = config.api_endpoint.USER_BY_PERMISSION_ENDPOINT;
  const payload = { permission: "my_ideas.limited_access_ideas_list"}

  return await Request.post({ url: endpoint, payload: payload });
}
